import React, { useEffect, useState, useRef, useContext } from 'react';
import { Button, Select, DatePicker, Table } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import config from '../../../Config';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/date-picker/locale/zh_CN';
import en_US from 'antd/lib/date-picker/locale/en_US';
import { useTranslation } from 'react-i18next';
import { red } from '@material-ui/core/colors';

function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().top
    }
    let height = `calc(100vh - ${tHeaderBottom + 100}px)`
    return height
}

function DataHistoryUhomeSinglePhase(props) {
    const { t, i18n } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, model, protocol, handleSelectSN } = props
    const setTip = useContext(utils.tipContext)

    const [dataHistoryDate, setDataHistoryDate] = useState(moment().format('YYYY-MM-DD')) //时间
    const [aWeekAgoDate, setAWeekAgoDate] = useState(moment().subtract(7, 'days').format('YYYY-MM-DD'))  //一周前的日期, 导出用

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(100)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)
    const [loading, setLoading] = useState(false)


    const refDownloader1 = useRef(null)
    const refDownloader2 = useRef(null)

    const [scrollY, setScrollY] = useState("")

    useEffect(() => {
        setScrollY(getTableScroll())
    }, [])

    //取历史数据
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("integrated-inverter/uhome-singlephase/history/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                SerialNumber: SN,
                STime: moment(dataHistoryDate).format("YYYY-MM-DD"),
                ETime: moment(dataHistoryDate).add(1, "days").format("YYYY-MM-DD"),
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setRowTotal(0)
                setRows([])
                return;
            }
            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, SN, dataHistoryDate, t]);

    const handleExport = () => {
        if (!refDownloader1.current) {
            return;
        }
        refDownloader1.current.click()
    }

    const handleExportWeek = () => {
        if (!refDownloader2.current) {
            return;
        }
        refDownloader2.current.click()
    }

    //根据不同逆变器显示不同字段
    const DefaultColumns = [
        {
            title: "",
            width: 40,
            fixed: 'left',
            render: (v, r, idx) => {
                return (pageNo * pageSize + idx + 1);
            }
        }, {
            title: t('CreateTime'),
            dataIndex: 'CreateTime',
            width: 160,
            fixed: 'left',
        }, {
            title: t('Daily Grid Statistics (kWh)'),
            dataIndex: 'EDayToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily Load Statistics (kWh)'),
            dataIndex: 'EDayLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily PV Statistics (kWh)'),
            dataIndex: 'EDayPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly Grid Statistics (kWh)'),
            dataIndex: 'EMonthToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly Load Statistics (kWh)'),
            dataIndex: 'EMonthLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly PV Statistics (kWh)'),
            dataIndex: 'EMonthPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly Grid Statistics (kWh)'),
            dataIndex: 'EYearToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly Load Statistics (kWh)'),
            dataIndex: 'EYearLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly PV Statistics (kWh)'),
            dataIndex: 'EYearPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Current Machine Status'),
            dataIndex: 'Status',
            width: 200,
        }, {
            title: t('PV1 Voltage (V)'),
            dataIndex: 'VPV1',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV1 Current (A)'),
            dataIndex: 'IPV1',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV2 Voltage (V)'),
            dataIndex: 'VPV2',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV2 Current (A)'),
            dataIndex: 'IPV2',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('U Phase Voltage (AC Voltage A) (V)'),
            dataIndex: 'VAC1Grid',
            width: 240,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('U Phase Current (Output Current A) (A)'),
            dataIndex: 'IAC1Grid',
            width: 280,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('V Phase Voltage (AC Voltage B) (V)'),
            dataIndex: 'VAC1Load',
            width: 240,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('V Phase Current (Output Current B) (A)'),
            dataIndex: 'IAC1Load',
            width: 280,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('W Phase Voltage (AC Voltage C) (V)'),
            dataIndex: 'VAC1Inverter',
            width: 260,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('W Phase Current (Output Current C) (A)'),
            dataIndex: 'IAC1Inverter',
            width: 280,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Grid Frequency (Hz)'),
            dataIndex: 'GridHz',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Power Factor (Hz)'),
            dataIndex: 'PowerFactor',
            width: 160,
            render: (v) => {
                return (v * 0.001).toFixed(3);
            },
            transform: {
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Input Power (kW)'),
            dataIndex: 'InputPower',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Temperature 1 (℃)'),
            dataIndex: 'Temperature1',
            width: 160,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7ffff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Temperature 2 (℃)'),
            dataIndex: 'Temperature2',
            width: 160,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7ffff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Ground Resistance (MΩ)'),
            dataIndex: 'GroundResistance',
            width: 200,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Leakage Current (mA)'),
            dataIndex: 'LeakageCurrent',
            width: 160,
        }, {
            title: t('DC Component (mA)'),
            dataIndex: 'DCComponent',
            width: 160,
        }, {
            title: t('Voltage DC Component (MV)'),
            dataIndex: 'DCVoltageComponent',
            width: 200,
        }, {
            title: t('MIDBUS Voltage (V)'),
            dataIndex: 'MIDBUSVoltage',
            width: 160,
        }, {
            title: t('MIDGRID Voltage (V)'),
            dataIndex: 'MIDGRIDVoltage',
            width: 160,
        }, {
            title: t('Grid Side Cumulative Power Generation (kWh)'),
            dataIndex: 'ETotalToGrid',
            width: 320,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Load Side Cumulative Power Consumption (kWh)'),
            dataIndex: 'ETotalLoad',
            width: 330,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV Side Cumulative Power Generation (kWh)'),
            dataIndex: 'ETotalPV',
            width: 320,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV1 Power (kW)'),
            dataIndex: 'PPV1',
            width: 160,            
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV2 Power (kW)'),
            dataIndex: 'PPV2',
            width: 160,            
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Power (kW)'),
            dataIndex: 'PBattery',
            width: 160,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Grid Side Active Power (kW)'),
            dataIndex: 'PAC1Grid',
            width: 200,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Grid Side Reactive Power (kW)'),
            dataIndex: 'QAC1Grid',
            width: 220,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Load Side Active Power (kW)'),
            dataIndex: 'PAC1Load',
            width: 200,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.01).toFixed(2);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 100
            }
        }, {
            title: t('Load Side Reactive Power (kW)'),
            dataIndex: 'QAC1Load',
            width: 220,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Inverter Side Active Power (kW)'),
            dataIndex: 'PAC1Inverter',
            width: 230,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.01).toFixed(2);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 100
            }
        }, {
            title: t('Inverter Side Reactive Power (kW)'),
            dataIndex: 'QAC1Inverter',
            width: 230,        
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.001).toFixed(3);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 1000
            }
        }, {
            title: t('BMS Full Charge Indicator'),
            dataIndex: 'BMSFullCharged',
            width: 200,
        }, {
            title: t('Battery Charging Voltage Limit (V)'),
            dataIndex: 'BatteryChargeVoltageLimit',
            width:260,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Charging Current Limit (A)'),
            dataIndex: 'BatteryChargeCurrentLimit',
            width: 260,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Discharging Current Limit (A)'),
            dataIndex: 'BatteryDischargeCurrentLimit',
            width: 260,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Capacity (%)'),
            dataIndex: 'BatteryCapacity',
            width: 200,
        }, {
            title: t('Battery Health Status (%)'),
            dataIndex: 'BatteryStatus',
            width: 220,
        }, {
            title: t('Battery Voltage (V)'),
            dataIndex: 'VBattery',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Current (A)'),
            dataIndex: 'IBattery',
            width: 160,       
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Temperature (℃)'),
            dataIndex: 'BatteryTemperature',
            width: 260,       
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Discharge Voltage Limit (V)'),
            dataIndex: 'BatteryDischargeVoltageLimit',
            width: 280,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Charging Current (A)'),
            dataIndex: 'BatteryChargeCurrent',
            width: 230,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Combination Status'),
            dataIndex: 'CombinationStatus',
            width: 200,
            render: (v) => {
                let map = {
                    0: t("Not in combination"),
                    1: t("In combination"),
                    2: t("Combination fault"),
                    3: t("Off-grid combination success"),
                    4: t("Grid-connected combination success")
                }
                return map[v]??"";
            },
            transform: {
                map: {
                    0: t("Not in combination"),
                    1: t("In combination"),
                    2: t("Combination fault"),
                    3: t("Off-grid combination success"),
                    4: t("Grid-connected combination success")
                }
            }
        }, {
            title: t('Combination Mode'),
            dataIndex: 'CombinationMode',
            width: 200,
            render: (v) => {
                let map = {
                    1: t("Standby"),
                    2: t("Fault"),
                    3: t("Off-grid combination"),
                    4: t("Grid-connected combination")
                }
                return map[v]??"";
            },
            transform: {
                map: {
                    1: t("Standby"),
                    2: t("Fault"),
                    3: t("Off-grid combination"),
                    4: t("Grid-connected combination")
                }
            }
        }, {
            title: t('Combination Comm Anomaly'),
            dataIndex: 'CombinationCommAnomaly',
            width: 220,
            render: (v) => {
                let map = {
                    1: t("Abnormal"),
                    0: t("Normal")
                }
                return map[v]??"";
            },
            transform: {
                map: {
                    1: t("Abnormal"),
                    0: t("Normal")
                }
            }
        }, {
            title: t('Combination Fault Code'),
            dataIndex: 'CombinationFaultCode',
            width: 220,
            render: (v) => {
                let bitmap = [{
                    range:[0],
                    values:{
                        1: t("CANID conflict"),
                    }
                },{
                    range:[1],
                    values:{
                        1: t("ID configuration out of range"),
                    }
                },{
                    range:[2],
                    values:{
                        1: t("Inverter lost"),
                    }
                },{
                    range:[3],
                    values:{
                        1: t("Master lost"),
                    }
                },{
                    range:[4],
                    values:{
                        1: t("Multiple masters"),
                    }
                },{
                    range:[5],
                    values:{
                        1: t("Off-grid synchronization failure"),
                    }
                },{
                    range:[7],
                    values:{
                        1: t("Incorrect number of combination inverters"),
                    }
                },{
                    range:[8],
                    values:{
                        1: t("No master"),
                    }
                },{
                    range:[9],
                    values:{
                        1: t("Imbalance in the number of single-phase machines"),
                    }
                },{
                    range:[10],
                    values:{
                        1: t("Missing one or two phases"),
                    }
                }];
                let vs = [];
                bitmap.forEach((c) => {
                    let s = c.values[((v>>c.range[0])&1)] ?? "";
                    if (s != "") {
                        vs.push("("+(c.range[0]+1).toString() + ") " + s);
                    }
                })
                return <span style={{ whiteSpace: 'normal' }}>{vs.join("; ")}</span>;

            },
            transform: {
                bitmap: [{
                    range:[0],
                    values:{
                        1: t("CANID conflict"),
                    }
                },{
                    range:[1],
                    values:{
                        1: t("ID configuration out of range"),
                    }
                },{
                    range:[2],
                    values:{
                        1: t("Inverter lost"),
                    }
                },{
                    range:[3],
                    values:{
                        1: t("Master lost"),
                    }
                },{
                    range:[4],
                    values:{
                        1: t("Multiple masters"),
                    }
                },{
                    range:[5],
                    values:{
                        1: t("Off-grid synchronization failure"),
                    }
                },{
                    range:[7],
                    values:{
                        1: t("Incorrect number of combination inverters"),
                    }
                },{
                    range:[8],
                    values:{
                        1: t("No master"),
                    }
                },{
                    range:[9],
                    values:{
                        1: t("Imbalance in the number of single-phase machines"),
                    }
                },{
                    range:[10],
                    values:{
                        1: t("Missing one or two phases"),
                    }
                }]
            }
        }, {
            title: t('Combination Slave-SN1'),
            dataIndex: 'CombinationSlaveSN1',
            width: 200
        }, {
            title: t('Combination Slave-SN2'),
            dataIndex: 'CombinationSlaveSN2',
            width: 200
        }, {
            title: t('Combination Slave-SN3'),
            dataIndex: 'CombinationSlaveSN3',
            width: 200
        }, {
            title: t('Combination Slave-SN4'),
            dataIndex: 'CombinationSlaveSN4',
            width: 200
        }, {
            title: t('Combination Slave-SN5'),
            dataIndex: 'CombinationSlaveSN5',
            width: 200
        }, {
            title: t('Combination Slave-SN6'),
            dataIndex: 'CombinationSlaveSN6',
            width: 200
        },
    ];
    let strColumns = [];
    for (let i = 0; i < DefaultColumns.length; i++) {
        const c = DefaultColumns[i];
        if (c.dataIndex) {
            strColumns.push({
                title: c.title,
                dataIndex: c.dataIndex,
                transform: c.transform,
                width: c.width,
            });
        }
    }
    strColumns = encodeURIComponent(JSON.stringify(strColumns));

    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: "none", padding: "10px" }}>
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t("Enter Inverter Name")}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px', marginLeft: '10px' }}
                >{inverterSelectOptions}</Select>
                <DatePicker
                    defaultValue={moment()}
                    value={moment(dataHistoryDate)}
                    onChange={(_, ds) => {
                        setDataHistoryDate(ds)
                        setAWeekAgoDate(moment(ds).subtract(7, 'days').format('YYYY-MM-DD'))
                    }}
                    allowClear={false}
                    locale={i18n.language === 'zh' ? zh_CN : en_US}
                />

                {/* <Button type="primary" disabled={rows.length < 1 ? true : false} onClick={handleExportWeek} style={{ float: 'right', marginRight: '10px', backgroundColor: '#0486be', color: '#fff' }}>{t('Export Data')}({dataHistoryDate} - {aWeekAgoDate})</Button> */}
                <Button type="primary" disabled={rows.length < 1 ? true : false} onClick={handleExport} style={{ float: 'right', marginRight: '10px', backgroundColor: '#0486be', color: '#fff' }}>{t('Export Data')}</Button>
            </div>
            <div style={{ flex: "auto", overflow: "hidden" }}>
                <Table
                    columns={DefaultColumns}
                    pagination={{
                        pageSizeOptions: [25, 50, 100],
                        current: pageNo + 1,
                        pageSize: pageSize,
                        total: rowTotal,
                        showSizeChanger: true,
                        showTotal: (total) => { return t('Total {{total}}', { total }) },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                        },
                        onChange: (page, pageSize) => {
                            setPageNo(page - 1);
                        }
                    }}
                    tableLayout="fixed"
                    bordered={true}
                    size="small"
                    loading={loading}
                    rowKey="ID"
                    dataSource={rows}
                    scroll={{ x: 'max-content', y: scrollY }}
                >
                </Table>
            </div>

            <a ref={refDownloader1} style={{ display: "none" }} href={config.apiUrl + "data-export/uhome-singlephase/inverter/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&SDate=" + dataHistoryDate + "&EDate=" + moment(dataHistoryDate).add(1, 'days').format('YYYY-MM-DD') + "&Columns=" + strColumns}></a>
            {/* <a ref={refDownloader2} style={{ display: "none" }} href={config.apiUrl + "data-export/uhome-singlephase/inverter/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&SDate=" + aWeekAgoDate + "&EDate=" + dataHistoryDate + "&Columns=" + strColumns}></a> */}
        </div>
    )
}

export default DataHistoryUhomeSinglePhase;